'use strict';

import _ from 'underscore';
import $ from 'jquery';
import config from '../../js/config';
import ProductPricingService from '../../services/ProductPricingService';
import GenericSearchModel from '../Search/genericSearchModel';
import ProductPricingView from './ProductPricingView';

const productPricingViews = [];

/**
 * Create views based on the elements passed in.
 * Each view is created in a separate stack because it was taking too long
 * and causing slow function
 *
 * @param $elements .ProductPricing
 * @returns {Promise.<*>}
 */
export function createPricingViews($elements) {
  return Promise.all(
    _.map($elements, el => {
      return new Promise(resolve => {
        _.delay(() => {
          productPricingViews.push(new ProductPricingView({ el }));
          resolve();
        });
      });
    })
  );
}

export function createModelsToLoad($elements) {
  createPricingViews($elements)
    .then(() => {
      // Unique to ensure we are not requesting the same product twice
      let uniqueViews = _.uniq(productPricingViews, function(productPricingView) {
        return productPricingView.partId + productPricingView.manufacturer + productPricingView.partNumber;
      });

      // Get the models which are needed to request the buying options
      let models = uniqueViews.map((productPricingView) => {
        return new GenericSearchModel({
          partId: productPricingView.partId,
          searchResultType: config.search.resultTypeProduct
        });
      });

      _.delay(() => {
        ProductPricingService.requestPricingIfRequired(models);
      });
    });
}

export function create($parent) {
  // Find the views that require the pricing to be loaded
  let $elements = $parent.find('.ProductPricing').filter(function(n, el) {
    let $el = $(el),
      partId = $el.data('part-id'),
      partNumber = $el.data('sku'),
      manufacturer = $el.data('manufacturer');

    // Can only find prices if we have all of the required data
    return (partId || (partNumber && manufacturer));
  });

  if (!$elements.length) {
    return;
  }

  createModelsToLoad($elements);
}



// WEBPACK FOOTER //
// ./assets/components/ProductPricing/ProductPricingLoader.js